import { NgModule } from '@angular/core';

export const PERMISSION_MANAGE_ROLES = '40E4D834-983D-EC11-96EF-20791866B73B';
export const PERMISSION_MANAGE_USERS = '41E4D834-983D-EC11-96EF-20791866B73B';
export const PERMISSION_SITES_READ = '43E4D834-983D-EC11-96EF-20791866B73B';
export const PERMISSION_SITES_EDIT = '44E4D834-983D-EC11-96EF-20791866B73B';
export const PERMISSION_CTMS_ACCESS = 'BAF78956-79ED-4009-9C98-F350C6C43BA0';

@NgModule({
})
export class PermissionIds { }
